import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { PlanillaEvaluacion } from '@/app/models/interface/planilla-evaluacion.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class PlanillaEvaluacionService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'planilla-evaluacion/';

  create(data: Partial<PlanillaEvaluacion>) {
    return this.http
      .post<CustomResponse<PlanillaEvaluacion>>(this.url, data)
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return {
            ...d,
          };
        }),
      );
  }

  findAll(
    params?: HttpParams,
  ): Observable<PaginatorModel<PlanillaEvaluacion[], HasPagination>> {
    return this.http
      .get<
        CustomResponse<PaginatorModel<PlanillaEvaluacion[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;

          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((capacitacion) => {
                return {
                  ...capacitacion,
                };
              }),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<PlanillaEvaluacion>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
          };
        }
        return d;
      }),
    );
  }

  update(data: Partial<PlanillaEvaluacion>) {
    const url = this.url + data.id;
    return this.http.put<CustomResponse<PlanillaEvaluacion>>(url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
          };
        }
        return d;
      }),
    );
  }

  changeState(state: boolean, id: string) {
    const url = this.url + id;
    return this.http
      .patch<CustomResponse<PlanillaEvaluacion>>(url, { state })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d) {
            return {
              ...d,
            };
          }
          return d;
        }),
      );
  }
}
